export default __webpack_public_path__ + "static/media/image1.97c37ced.jpg";